import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

/** Ordem alinhada à homepage: Hero → Company → Pricing → Solutions → Process → Why TM RUSH → Team → Testimonials → Footer */
const navItems = [
  { label: 'Company', id: 'company' },
  { label: 'Pricing', id: 'pricing' },
  { label: 'Solutions', id: 'solutions' },
  { label: 'Process', id: 'process' },
  { label: 'Why TM RUSH', id: 'why-tm-rush' },
  { label: 'Team', id: 'team' },
  { label: 'Contact', id: 'contact' },
];

const Header = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const getNavTarget = (id) => {
    if (id === 'team') {
      if (location.pathname === '/about') return '#team';
      if (location.pathname === '/') return '#team';
      return '/#team';
    }
    return location.pathname !== '/' ? `/#${id}` : `#${id}`;
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const yOffset = -96;
      const y = element.offsetTop + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  const handleNavClick = (e, id) => {
    e.preventDefault();
    e.stopPropagation();
    setIsMenuOpen(false);
    scrollToSection(id);
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white shadow-sm z-50 border-b border-gray-100">
      <nav className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img
              src="/images/tm-rushlogo.svg"
              alt="TM RUSH Logo"
              className="h-8 md:h-10 w-auto"
            />
          </Link>

          <div className="hidden lg:flex items-center space-x-6">
            {navItems.filter((item) => item.id !== 'company').map((item) => {
              const target = getNavTarget(item.id);
              if (location.pathname !== '/') {
                return (
                  <Link
                    key={item.id}
                    to={target}
                    className="text-gray-700 hover:text-text font-medium text-sm"
                  >
                    {item.label}
                  </Link>
                );
              }
              return (
                <a
                  key={item.id}
                  href={target}
                  className="text-gray-700 hover:text-text font-medium text-sm"
                  onClick={(e) => handleNavClick(e, item.id)}
                >
                  {item.label}
                </a>
              );
            })}
            <Link
              to="/brazil-watch"
              className="text-gray-700 hover:text-text font-medium text-sm whitespace-nowrap"
            >
              Brazil Watch
              <span className="ml-1.5 text-[10px] font-bold text-primary-dark bg-primary/15 px-1.5 py-0.5 rounded-full align-middle">NEW</span>
            </Link>
            <Link
              to="/client"
              className="text-text border border-gray-300 px-4 py-2 rounded-lg hover:border-primary hover:text-primary-dark font-semibold text-sm whitespace-nowrap"
            >
              Client login
            </Link>
            <Link
              to="/order"
              className="bg-primary text-white px-6 py-2 rounded-lg hover:bg-primary-hover font-semibold shadow-md hover:shadow-lg text-sm whitespace-nowrap"
            >
              Start Application
            </Link>
          </div>

          <button
            className="lg:hidden text-gray-700"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {isMenuOpen && (
          <div className="lg:hidden mt-4 space-y-4 pb-4">
            {navItems.map((item) => {
              const target = getNavTarget(item.id);
              if (location.pathname !== '/') {
                return (
                  <Link
                    key={item.id}
                    to={target}
                    className="block text-gray-700 hover:text-gray-900"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item.label}
                  </Link>
                );
              }
              return (
                <a
                  key={item.id}
                  href={target}
                  className="block text-gray-700 hover:text-gray-900"
                  onClick={(e) => handleNavClick(e, item.id)}
                >
                  {item.label}
                </a>
              );
            })}
            <Link
              to="/brazil-watch"
              className="block text-gray-700 hover:text-gray-900"
              onClick={() => setIsMenuOpen(false)}
            >
              Brazil Watch
            </Link>
            <Link
              to="/client"
              className="block text-gray-700 hover:text-gray-900"
              onClick={() => setIsMenuOpen(false)}
            >
              Client login
            </Link>
            <Link
              to="/order"
              className="w-full bg-primary text-white px-6 py-2 rounded-lg hover:bg-primary-hover font-semibold shadow-md text-center block"
              onClick={() => setIsMenuOpen(false)}
            >
              Start Application
            </Link>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
